class MediaVideoPopup extends HTMLElement {
  constructor () {
    super();
    this.attachEvents();
  }

  attachEvents () {
    this.querySelectorAll('.media-card__link--video').forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();

        const popupId = trigger.dataset.videoId;
        if (!popupId) return;

        const popup = this.querySelector(`#${popupId}`);
        if (!popup) return;

        popup.hidden = false;
        document.body.classList.add('video-popup-open');
      });
    });

    this.querySelectorAll('.media-card__popup-close').forEach(btn => {
      btn.addEventListener('click', () => {
        const popup = btn.closest('.media-card__popup');
        if (!popup) return;

        this.closePopup(popup);
      });
    });

    this.querySelectorAll('.media-card__popup').forEach(popup => {
      popup.addEventListener('click', (e) => {
        if (e.target === popup) {
          this.closePopup(popup);
        }
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;

      this.querySelectorAll('.media-card__popup:not([hidden])').forEach(popup => {
        this.closePopup(popup);
      });
    });
  }

  closePopup (popup) {
    popup.hidden = true;
    document.body.classList.remove('video-popup-open');

    const iframe = popup.querySelector('iframe');
    if (iframe) {
      iframe.src = iframe.src;
    }

    const video = popup.querySelector('video');
    if (video) {
      video.pause();
    }
  }
}

window.customElements.define('media-video-popup', MediaVideoPopup);
